/*
 * @ProjectName: vra
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2021-01-11 13:56:52
 * @LastEditTime: 2021-01-11 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/service/feeAuditService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";

/**
 * feeAudit列表
 */
export function getFeeAuditData(Info) {
  return request({
    url:
      "/api/v1/newborn/apply/list?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 新建feeAudit页面数据
 */
export function createFeeAudit(data) {
  return request({
    url: "/api/v1/feeAudit",
    method: "POST",
    data: data
  });
}
/*
 * 审批（同意）
 */
export function AgreeFeeAudit(data) {
  return request({
    url: "/api/v1/newborn/apply/" + data.id + "/audit/agree",
    method: "PATCH",
    data: data.data
  });
}
/*
 * 审批（拒绝）
 */
export function rejectFeeAudit(data) {
  return request({
    url: "/api/v1/newborn/apply/" + data.id + "/audit/refuse",
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取feeAudit数据详情
 */
export function getFeeAuditInfo(id) {
  return request({
    url: "/api/v1/newborn/apply/" + id,
    method: "GET"
  });
}
/*
 * 删除feeAudit数据
 */
export function deleteFeeAudit(id) {
  return request({
    url: "/api/v1/feeAudit/" + id,
    method: "DELETE"
  });
}
/**
 * 下载zip包
 */
export function downloadFeeAudit(data) {
  return request({
    url: "/api/v1/newborn/downloadzip",
    method: "POST",
    responseType: "blob",
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/service/feeAuditService.js